/*
semsomi AB
Copyright (c) 2016-2017
All rights reserved
*/


import React, {Component} from 'react';
import Feed from'./feed.jsx';
import {browserHistory} from 'react-router';
// import ReactCSSTransitionGroup from 'react-addons-css-transition-group';
import BottomBar from './bottomBar';
import { connect } from 'react-redux';
import store from '../store';
import Profile from './profile.jsx';
import { updateMenu } from '../actions/feed';
import {saveProfile} from '../actions/auth';
import {setting} from '../util.js';
import TT from './modal/tt.jsx';
// import {fetchFeed} from '../apiFunctions';

let autosaveTimer = null //PERHAPS THIS SHOULDNT BE OUTSIDE THE REACT COMPONENT

const callbackUrl = encodeURIComponent("https://www.monok.com/profile/settings")
const integrationConnections = {
  facebook:`https://www.facebook.com/v19.0/dialog/oauth?client_id=387411317431132&redirect_uri=${callbackUrl}&state=lkfdjglkdjnmrglifdvjnjfkvnhsdwqewqecewfdsdFA&scope=pages_manage_posts,pages_show_list,business_management,pages_read_engagement`,
  twitter:`https://twitter.com/i/oauth2/authorize?response_type=code&client_id=NUJTLXBCZDdvSnZjTVZEcFZtdmQ6MTpjaQ&redirect_uri=${callbackUrl}&scope=media.write%20offline.access%20tweet.read%20tweet.write%20users.read&state=lkjSAHDFasdfuy7y678ydskfjhasdf6gtwitter&code_challenge=challenge&code_challenge_method=plain`,
  linkedin:`https://www.linkedin.com/oauth/v2/authorization?response_type=code&client_id=77x1zp81pk71z2&redirect_uri=${callbackUrl}&state=lkjSAHDFasdfuy7y678ydskfjhasdf6gHGSDg&scope=r_emailaddress%20r_liteprofile%20w_member_social%20rw_organization_admin%20r_organization_social%20r_basicprofile%20w_organization_social%20w_member_social`
}

class Feeds extends React.Component {


  constructor(props) {
    super(props)
    this.updateScroll = this.updateScroll.bind(this);
    this.state = {
      top:true
    }
  }

  lessThanOneDayOld = (date) => {
    const hour= 1000 * 60 * 60;
    const dayAgo= Date.now() - hour*24;

    return date > dayAgo;
  }

  today(feed){
   let freq = feed.articleGeneration ? feed.articleGeneration.find(se=>se.value && se.value.startsWith('frequency:')) : null
   return freq.value.split(':')[1].toLowerCase()
  }

  stringToPastelColor(str) {
    // Simple hash function
    let hash = 0;
    for (let i = 0; i < str.length; i++) {
      hash = str.charCodeAt(i) + ((hash << 5) - hash);
    }

    // Convert hash to HSL with high lightness and low saturation (pastel)
    const h = hash % 360;
    const s = 40 + (hash % 20); // 40–60% saturation
    const l = 85; // lightness is high for pastels

    return `hsl(${h}, ${s}%, ${l}%)`;
  }

// feed.id==='profile' && feed.puffs.length===0 && !feed.isFetching ? undefined :
  getPage(feed, className, selectedProject, selectedFilter){
    if(!feed){
      return null
    }
  
    let {feeds, location, mobile, user} = this.props
 
    let warnings = []
   
    let disconnected = feeds && user.websites ? user.websites.filter(target=>['404', '440'].includes(target.status) && feeds.find(f=>f.enabled && f.onSubmit && f.onSubmit.find(oTarget=>target.url===oTarget.url))) : []

    if(feeds && user.websites){
      let disconnected = user.websites.filter(target=>['404', '440'].includes(target.status) && feeds.find(f=>f.enabled && f.onSubmit && f.onSubmit.find(oTarget=>target.url===oTarget.url)))
      warnings = warnings.concat(disconnected)
    }

    let note = null

    if(warnings.length>0){
      note = <p onClick={(e)=>{
        // e.preventDefault()
        e.stopPropagation()
        this.setState({expandNote:true})
      }} style={{margin:0, fontWeight:'bold'}}>

          {warnings.length===1 ? `One of your ${warnings[0].type==='wp' ?  'websites has a disabled Monok WordPress plugin' : 'integrations is disconnected'}` : `Some of your ${warnings.filter(p=>p.type==='wp').length===warnings.length ? 'websites' : 'integrations'} are disconnected`}, click here to resolve this

          {this.state.expandNote ? 
            <div style={{fontWeight:'normal', marginTop:30}}>
              {warnings.map(target=><p>{target.url} - {target.type === 'wp' ? `Install or activate the plugin` : 'Reconnect the integration'} <a href={integrationConnections[target.type] ? integrationConnections[target.type] : target.url+"/wp-admin/plugins.php"} target={target.type==='wp' ? "_blank" : "_self"}>here</a></p>)}
              <p style={{    
                marginTop: 50,
                fontStyle: 'italic'}}>Once the plugin is activated, new and old articles will be pushed out automatically</p>
            </div> : 
          null}

      </p>
    }

    let sub = location && location.pathname && location.pathname.split('/') ? location.pathname.split('/')[2] : null
    

               
    let myFeeds = <div onClick={()=>{
      this.setState({expandNote:false})
    }} style={{fontSize:'x-large', width:'100%', margin:'30px auto 10px auto', maxWidth:1135, display: 'flex', justifyContent: 'flex-start', flexWrap: 'wrap'}}>
                    
                    

                    {selectedProject && selectedProject.value!=='archive' ? <div style={{width:'100%', display:'flex'}}>

                    <input onChange={(e)=>{
                      if(selectedProject.value==='newproject'){
                       
                        const myArray = new Uint32Array(1);
                        let newProj = {faicon:'fa fa-circle', type:"page", title:e.target.value==='' ? 'Untitled Project' : e.target.value, value:crypto.getRandomValues(myArray)[0].toString(), group:1}
                        this.props.saveProfile({projects:user.projects ? [{title:newProj.title, id:newProj.value}].concat(user.projects) : [{title:newProj.title, id:newProj.value}]}, true) 
                        feed.menu.splice(feed.menu.findIndex(s=>s.type==='page' && s.value==='')+1, 0, newProj)
                        this.props.updateMenu(feed, feed.menu)
                        browserHistory.push({pathname: '/profile/'+newProj.value})
                      }else{
                        feed.menu[feed.menu.findIndex(s=>s.type==='page' && s.value===selectedProject.value)].title = (e.target.value==='' ? 'Untitled Project' : e.target.value)
                        this.props.updateMenu(feed, feed.menu)
                        if(autosaveTimer){
                          window.clearTimeout(autosaveTimer)
                        }
                        autosaveTimer = setTimeout(() => {
                            this.props.saveProfile({projects:user.projects.map(p=>p.id===selectedProject.value ? {...p, title:selectedProject.title} : p)}, true)
                        }, "3000");
                      }
                    }} autoFocus={selectedProject.title.toLowerCase()==='new project'} 
                      type="text" value={selectedProject.title} style={{border:'none',border:selectedProject.value==='newproject' ? 'solid 3px' : 'none'  , borderRadius:10, background:'transparent', width: '100%', paddingLeft:10, marginBottom:60, fontWeight: 'bold', fontSize: 'clamp(25px, 8vw, 40px)'}}/> 

                        {selectedProject && !['newproject','archive'].includes(selectedProject.value) && feeds.filter(f=>f.project===selectedProject.value).length===0 ? 
                        <TT text={'Permanently delete this project'}>
                        <div tabIndex="0" onBlur={()=>false ? this.setState({sure:{}}) : null} onClick={()=>{
                          this.props.saveProfile({projects:user.projects.filter(p=>p.id!==selectedProject.value)}, true) 
                          feed.menu = feed.menu.filter(s=>!(s.type==='page' && s.value===selectedProject.value))
                          this.props.updateMenu(feed, feed.menu)
                          browserHistory.push({pathname: '/profile'})
                        }} className="blueButton borderButton highlight" style={{fontSize: 'medium', minWidth: 255, ...(false ? {background:'black', color:'white', padding:'13px 15px'} : {padding:'13px 15px'})}}>
                            Delete this project <span className={"fa fa-trash buttonConf ani"} style={false ? {width:20, marginLeft:5} : {}}></span>
                        </div></TT> : null}

                      </div>
                      : 
                    (user.writer ? null : <h1 style={{width: '100%', paddingLeft:10, marginBottom:60, fontWeight: 'bold', fontSize: 'clamp(25px, 8vw, 40px)'}}>{user.curator ? new Date().toUTCString().split(/\d\d:/)[0].trim() : (selectedProject ? selectedProject.title : "My Subscriptions")}</h1>)}
                      
                    {selectedProject && selectedProject.value==='newproject' ? 
                    [<p>Type the name of your new project ⭐</p>, <p style={{opacity:0.5}}>Projects can contain multiple feeds, an easy way for you to organize your subscriptions.</p>] 
                    : null}
                    {note ? <div style={{
                                            width: '100%',
                                            background: 'rgb(255, 246, 168)',
                                            cursor:this.state.expandNote ? undefined : 'pointer',
                                            padding: '5px 20px',
                                            borderRadius: 10,
                                            margin: '20px 15px'
                                        }}>{note}</div> : null}
                    {user.writer || user.curator || (selectedProject && ['newproject', 'archive'].includes(selectedProject.value)) ? null : <div key={"feedtagNew"} onClick={()=>{
                                          browserHistory.push({pathname: '/profile/new', query: selectedProject && selectedProject.value && selectedProject.value.length>0 ? {project:selectedProject.value} : undefined})
                                        }} className="feedCard cardHighlight greenHighlight" 
                                          style={{alignItems: 'center', justifyContent: 'space-around'}}>
                                          <span className="fa fa-plus plus"></span>
                                          <p style={{ marginTop: -50, marginBottom: -35}}>New Feed</p>
                                        </div>}
                    {feeds ? (user.curator ? feeds
                          .sort((a,b)=>a.curation && a.curation.tocurate>0 ? 1 : (b.curation && b.curation.tocurate>0 ? -1 : 0)) : feeds)
                          .filter(f=>{

                            let project = selectedProject ? f.project===selectedProject.value : (f.project==='archive' ? false : true)
                            
                            if(project){
                              if(selectedFilter && selectedFilter.value){
                                let prefix = selectedFilter.value.split(':')[0]
                                let val = selectedFilter.value.split(':')[1]
                                if(prefix==='language'){
                                  let flang = setting(f.articleGeneration, 'language', 'en')
                                  if(val==='other'){
                                    let notThese = feed.menu.filter(m=>m.type==='filter' && m.value.startsWith('language:')).map(m=>m.value.split(':')[1])
                                    return !notThese.includes(flang)
                                  }else{
                                    return flang===val
                                  }
                                }else if(prefix==='status'){
                                  return ((val==='running' && f.enabled) || (val==='paused' && !f.enabled))
                                }else if(prefix==='site'){
                                  if(val==='other'){
                                    let notThese = feed.menu.filter(m=>m.type==='filter' && m.value.startsWith('site:')).map(m=>m.value.split(':')[1])
                                    return (!f.onSubmit || !f.onSubmit.find(target=>notThese.find(notUrl=>target.url.includes(notUrl))))
                                  }else{
                                    return f.onSubmit && f.onSubmit.find(target=>target.url.includes(val))
                                  }
                                }
                              }else{
                                return true
                              }
                            }else{
                              return false
                            }
                          })
                          .filter(f=>!['profile', 'search','en','login'].includes(f.id) && (user.curator ? f.curation && !(f.curation.done || f.curation.total<1) : true))
                          // .filter(f=>!['profile', 'search','en','login'].includes(f.id) && !(feed.curation && feed.curation.done))
                          .sort((a,b)=>a.enabled ? -1 : 1)
                          .map((feed,i)=>{
                            let targetWebsite = feed.onSubmit ? feed.onSubmit.find(target=>target.type==='wp') : null
                            let fullIntegration = targetWebsite ? disconnected.find(target=>target.url === targetWebsite.url) : null
                            if(fullIntegration && targetWebsite){
                              targetWebsite = {...targetWebsite, ...fullIntegration}
                            }
                            
                            let feedProject = feed.project && user.projects ? user.projects.find(s=>s.id===feed.project) : null
                          
                            let targetLanguage = setting(feed.articleGeneration, 'language', 'en')
                            let lang = window.languages.find(l=>l.code === targetLanguage)
                            let perDay = setting(feed.articleGeneration, 'curate', 1)
                            let freq = setting(feed.articleGeneration, 'frequency', 'daily')
                            
                            let infoBadges = [
                              `${perDay} article${perDay>1 ? 's' : ''} ${{monthly:'monthly', daily:'daily', weekdays:'per weekday', weekends:'per weekend', weekly:'per week'}[freq]}`,
                              `${setting(feed.articleGeneration, 'nrOfWords', 300)} words`,
                              (lang && !['en'].includes(targetLanguage) ? lang.title : null)].filter(b=>b)

                           return <div key={"feedtag"+i} onClick={()=>{
                                browserHistory.push({pathname: '/'+feed.id, query:targetWebsite && targetWebsite.status==='404' ? {configureFeed:true} : null})
                              }} className="feedCard cardHighlight" style={{
                                // width:'25%',
                                position:'relative',
                                height:user.curator ? 200 : undefined,
                                opacity:feed.curation && (feed.curation.total<1 || feed.curation.done) && user.curator ? 0.3 : 1,
                                background: 'white'//feed.thumbnail ? "linear-gradient(to left, #e6646500 -120%, #ffffff 42%), url("+feed.thumbnail+") 226% 0% / auto 100%" : 'white'
                              }}>

                                  <div style={{width:'100%'}}>
                                    {feed.enabled ? <span className="fa fa-circle" style={{float:'right', marginLeft:10, color:'#8BC34A'}}></span> : null}
                                    {feed.logo ? <img src={'https://www.monok.com/api/v1/logoProxy?url='+feed.logo} className="silhouette"  style={{ maxWidth:'84%', maxHeight:30, filter: 'brightness(0)'}}/>  : <p style={{fontSize:'normal'}}>{feed.title}</p>}
                                  </div>
                                    {feed.logo ? <p style={{margin: '15px 0px 0px', opacity: 0.5, fontSize:'small'}}>{feed.title}</p> : null}
                                    {!selectedProject && feedProject ? <p style={{background: this.stringToPastelColor(feedProject.title), padding: '0px 10px', borderRadius: 5, fontWeight: 'bold'}}><span className="fa fa-circle"></span> {feedProject.title}</p> : null}
                                  {feed.categoryFilter && feed.categoryFilter[0] ? 
                                    <p style={{fontSize:'small', color:'#b9b9b9', textTransform: 'capitalize', height: '100%'}} className="textInShowcaseArticles">
                                      {feed.categoryFilter[0].categories.map(c=>typeof c ==='string' ? c.replace(/.+:/,'') : 'Error').filter((c,i,a)=>a.indexOf(c)===i).join(', ')}
                                    </p> : null}
                                    {
                                      // feed.location && feed.location[0] ? <p style={{fontSize: 'smaller', margin: 0}}>
                                      // <span className="glyphicon glyphicon-map-marker" style={{
                                      //   float: 'left',
                                      //   margin: '0px 5px'
                                      // }}></span>
                                      // {feed.location[0].value}</p> : null
                                    }

                                      <div className="moreInfo" style={{bottom: targetWebsite ? 35 : 10}}>
                                        {infoBadges.map(badge=><span style={{
                                            border: 'solid 1px #00000026',
                                            padding: '1px 10px',
                                            width: 'fit-content',
                                            borderRadius: '5px',
                                            float: 'left',
                                            background:'white',
                                            marginTop: 4,
                                            marginRight: 4
                                          }}>{badge}</span>)}
                                        
                                      </div>
                                      {targetWebsite ? <TT text={(targetWebsite && targetWebsite.status==='404' ? 'The WordPress plugin might be disabled' : 'Articles are sent to this website')}>
                                        <p style={{height: 25, position: 'absolute', bottom: 10, left: 10, right: 10, lineBreak: 'anywhere', overflow: 'hidden', marginBottom: 0, background: targetWebsite.status==='404' ? '#ffa0a0' : '#cdf1ff', fontSize: 'small', padding: 5, borderRadius: 5}}>{targetWebsite.url.replace(/https?:\/\/(www\.)?/,'')}</p>
                                        </TT> : null}
                                      
                                      {(user.admin || user.curator) && feed.updated && this.lessThanOneDayOld(feed.updated) ? <p style={{
                                        marginLeft: 'auto',
                                        background: '#ffc107',
                                        borderRadius: 5,
                                        zIndex: 100,
                                        padding: '0px 5px'
                                      }}>Recently Changed</p> : null}
                                      {feed.curation && user.curator ? <p style={{
                                        marginLeft: 'auto',
                                        background: 'yellow',
                                        borderRadius: 5,
                                        padding: '0px 5px'
                                      }}>{this.today(feed)}</p> : null}
                                       {feed.curation && feed.curation.curated !==0  && user.curator ? <p style={{
                                        marginLeft: 'auto',
                                        background: '#9fff2f',
                                        borderRadius: 5,
                                        padding: '0px 5px'
                                      }}>{feed.curation.curated}</p> : null}
                                      {feed.curation && feed.curation.tocurate !==0 && user.curator ? <p style={{
                                        marginLeft: 'auto',
                                        background: '#ffc0ee',
                                        borderRadius: 5,
                                        padding: '0px 5px'
                                      }}>{feed.curation.tocurate}</p> : null}
                              </div> 
                           

                          }) : null}
                    </div>


    if(feed.id==="profile"){
      return <Profile location={this.props.location} mobile={mobile} key={'profilepage'} feed={feed} myFeeds={myFeeds} updateScroll={this.updateScroll}/>
    }else{
      return <Feed style={feed.project === 'archive' ? {filter:'grayscale(1)'} : undefined} myFeeds={myFeeds} mobile={mobile} feed={feed} key={feed.id+'-feed'} id={feed.id} updateScroll={this.updateScroll}/>
    }  
  }


  updateScroll(e){
    window.dispatchEvent(new Event('parentScroll'));
    let top = e.currentTarget.scrollTop
    if(top>35 && this.props.onTop){
      this.setTop(false)
    }else if(top<35 && !this.props.onTop){
      this.setTop(true)
    }
  }

  setTop(is){
    this.props.setTop(is)
    // this.setState({top:is})
  }

  render (){

    let {feeds} = this.props
    const page = feeds[this.props.selectedView];
    let scrollable = page
    let normalPage = page && (["login","about"].includes(page.id) )//|| page.menu.find(m=>m.type==='view' && m.value==='magazine' && m.selected)

    let selectedProject = page && page.id==='profile' ? page.menu.find(m=>m.type==='page' && m.value!=='' && m.selected) : null
    let selectedFilter = page && page.id==='profile' ? page.menu.find(m=>m.type==='filter' && m.value!=='all' && m.selected) : null

    if(page && page.id==='profile'){
      normalPage=true
    }
    

    let landing = (page ? (page.info && page.info.landing) || (page.id==='search' && !page.info) : false)
    let parentScroller = landing || (scrollable && normalPage)
    let bottomBar = (page && page.id==='profile') || landing // normalPage //page && ['profile'].includes(page.id)
    let loading = page && page.isFetching



    let id = page && page.id ? (page.id + (parentScroller ? '-scroll' : '')) : 'scrollablepage'

    // return  <div id={id} style={{...style.rowFill, ...(loading ? {opacity:0.1, filter: 'contrast(0.01)'} : {})}} onScroll={landing || (scrollable && normalPage) ? this.updateScroll : undefined}>
    return  <div id={id} style={style.rowFill} onScroll={parentScroller ? this.updateScroll : undefined}>
                  <div  style={{width: '100%', 
                                height: 40, position: 'absolute',
                                zIndex: 10,
                                pointerEvents: 'none',
                                overflow:'hidden'
                                }}>                   
                 <div className="animate" style={{borderRadius: '85%',
                              height: 27,
                              top: -27,
                              position: 'relative',
                              maxWidth: 1400,
                              margin: 'auto',
                              // boxShadow: (this.state.top && scrollable ? '' : 'rgba(0, 0, 0, 0.35) 0px -18px 40px 25px')}}></div>
                              boxShadow: (this.props.onTop && (scrollable || parentScroller) ? '' : 'rgba(0, 0, 0, 0.35) 0px -18px 40px 25px')}}></div>
                  </div>
                  {this.getPage(page, null, selectedProject, selectedFilter)}
                  {bottomBar ? <BottomBar/> : null}
              </div>

  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    saveProfile:(newProfile, partial)=>dispatch(saveProfile(newProfile, partial)),
    updateMenu:(feed, menu)=>dispatch(updateMenu(feed, menu))
  }
}

const mapStateToProps = function(store) {
  return {
    feeds: store.feeds,
    selectedView: store.feeds.findIndex(f=>f.id === store.view.selectedView)
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Feeds);

const style = {
  rowFill:{display: 'flex', flexDirection: 'column', flex: 1, overflowY:'auto', overflowX:'hidden'}
}